module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-539.ed19e59.woff2";